import React from 'react'
import FeatureGraphs from 'components/featureGraphs'
import RadarGraph from 'components/radarGraph'
import PredictedAge from 'components/predictedAge'
import './styles.scss'
import {
  SpotifyGetAuthUri,
  SpotifyAuthUser,
  SpotifyGetUserAge,
  SpotifyGetTop50Tracks,
  SpotifyGetTracksInfo
} from 'components/display/lib/spotify'
import {
  FirestoreWriteUserToDb,
  FirestoreHandleRunningAverage
} from 'components/display/lib/firestore'
import { handlePredictAge } from 'components/display/lib/predictAge'
import { Waypoint } from 'react-waypoint'
import Scrollchor from 'react-scrollchor'

const isMobile = window.innerWidth < 720

class Display extends React.Component {
  constructor(props) {
    super(props)

    // Check access token
    this.accessToken = SpotifyAuthUser()
    let loggedIn = this.accessToken !== ''

    // Set default state
    this.state = {
      loggedIn: loggedIn,
      expired: false,
      loading: true,
      appData: null
    }

    this.trackLogin = this.trackLogin.bind(this)
  }

  static defaultProps = {
    authorizeUrl: SpotifyGetAuthUri()
  }

  componentDidMount() {
    // access token present, get data from api, save to db
    if (this.state.loggedIn) {
      let app = {
        user: {
          accessToken: this.accessToken,
          age: 0,
          topTracks: [],
          featureProfile: {},
          predictedAge: 0
        },
        audioFeatures: [
          'popularity', // Popularität    = track.popularity
          'valence', // Fröhlichkeit    = track.features.valence
          'energy', // Energie        = track.features.energy
          'speechiness', // Sprachanteil   = track.features.speechiness
          'acousticness', // Akustikanteil = track.features.acousticness
          'liveness', // Liveanteil     = track.features.liveness
          'danceability', // Tanzbarkeit    = track.features.danceability
          'duration_ms' // Songdauer       = track.features.duration_ms
        ],
        alreadyPresent: false,
        runningCount: 0,
        runningAge: 0,
        runningAverage: {}
      }

      SpotifyGetUserAge(app)
        .catch(error => {
          if (error.status === 401) {
            this.setState({ expired: true })
          }
        })
        .then(SpotifyGetTop50Tracks)
        .then(SpotifyGetTracksInfo)
        .then(handlePredictAge)
        .then(FirestoreWriteUserToDb)
        .then(FirestoreHandleRunningAverage)
        .catch(error => {
          console.log('there was an error')
          console.log(error)
        })
        .then(app => this.setState({ loading: false, appData: app }))
    }
  }

  handleLogin = (loggedIn, expired) => {
    if (expired) {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile ten wide tablet twelve wide computer column'>
              <p>
                Ihr Spotify-Token ist nicht mehr gültig, bitte melden Sie sich
                erneut an.
              </p>
            </div>
            <div className='ui middle aligned sixteen wide mobile six wide tablet four wide computer column'>
              <a
                href={this.props.authorizeUrl}
                onClick={this.trackLogin}
                className='fluid ui button right floated'
              >
                Anmelden
              </a>
            </div>
          </div>
        </div>
      )
    } else if (loggedIn) {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile column'>
              <img
                src={require('./img/check.svg')}
                style={isMobile ? { width: '30%' } : { width: '17%' }}
              />
              <h4>Vielen Dank!</h4>
              <p>
                In den untenstehenden Grafiken ist Ihre Position mit dem grünen
                Punkt <i className='circle icon green' /> markiert.
              </p>
              <p>
                Der blaue Punkt <i className='circle icon blue' />
                stellt den Durchschnittsleser dar.
              </p>
              <i className='icon big chevron down' />
            </div>
          </div>
        </div>
      )
    } else {
      return (
        <div className='spotify-login'>
          <div className='ui grid horizontal segments connector'>
            <div className='ui middle aligned sixteen wide mobile sixteen wide tablet sixteen wide computer column'>
              <div className='ui text container center aligned'>
                <img
                  src={require('./img/head.svg')}
                  style={isMobile ? { width: '35%' } : {}}
                />
              </div>
              <h4>Welchen Musikgeschmack haben Sie?</h4>
              <p>
                Melden Sie sich mit Spotify an und vergleichen Sie sich mit den
                Generationen und anderen Lesern. Erfahren Sie Ihr musikalisches
                Alter und Ihr ganz individuelles Profil.
              </p>
            </div>
            <div
              className='ui center aligned sixteen wide mobile sixteen wide tablet sixteen wide computer column'
              style={{ padding: '0 0 2em' }}
            >
              <a
                href={this.props.authorizeUrl}
                onClick={this.trackLogin}
                className='ui button'
              >
                <strong>Anmelden</strong>
              </a>
            </div>
          </div>
        </div>
      )
    }
  }

  trackLogin() {
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: 'connect to spotify'
    })
  }

  render() {
    const loggedIn = this.state.loggedIn
    const expired = this.state.expired
    const appData = this.state.appData
    return (
      <>
        <div className='ui'>
          <div className='ui text container'>
            <div className='section-headers'>
              {this.handleLogin(loggedIn, expired)}
            </div>
          </div>
        </div>

        {/* Background */}
        <div className='ui background'>
          <div className='ui container'>
            <div className='section-headers'>
              <h3 className='ui header'>
                {this.state.loggedIn
                  ? 'Ihr Musikgeschmack im Vergleich'
                  : 'Musikgeschmack im Vergleich'}
              </h3>
              <p style={{ paddingBottom: '1.5em' }}>
                Wir haben von Spotify die 100 meistgespielten Songs der
                jeweiligen Generation erhalten und die Durchschnittswerte von
                verschiedenen Eigenschaften dieser Songs im Folgenden als orange
                Linie <img src={require('./img/line.svg')} /> visualisert (
                <Scrollchor to='#methodik'>
                  <i
                    className='icon angle double down'
                    style={{ whiteSpace: 'nowrap' }}
                  />
                  Mehr zur Methodik
                </Scrollchor>
                ).
              </p>
            </div>
          </div>

          {/* Feature Graphs */}
          <div className='ui container featuregraphs'>
            <FeatureGraphs appData={this.state.loading ? false : appData} />
          </div>

          {/* Musikalisches Alter */}
          {appData ? (
            <>
              <div className='ui predictedage'>
                <div className='ui container section-headers'>
                  <h4 className='ui header'>Ihr musikalisches Alter</h4>
                  <div className='subheader'>
                    Berechnet aus den Eigenschaften Ihrer Top-100-Songs von
                    Spotify
                  </div>
                </div>
                <PredictedAge appData={appData} />
              </div>
            </>
          ) : (
            ''
          )}

          {/* Radar Graph */}
          {appData ? (
            <>
              <div className='ui radargraph'>
                <div className='ui container section-headers'>
                  <h4 className='ui header'>Ihr persönliches Musikprofil</h4>
                  <p className='radar-legende'>
                    <i className='circle icon green' /> Ihr Profil
                    <br />
                    <i className='circle icon blue' /> Profil Durchschnittsleser
                  </p>
                </div>
                <div className='ui text container'>
                  <RadarGraph appData={appData} />
                </div>
              </div>
            </>
          ) : (
            ''
          )}

          <Waypoint
            onEnter={event => {
              if (
                event.previousPosition === Waypoint.below &&
                event.currentPosition === Waypoint.inside
              ) {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  event: 'Interactions',
                  event_action: 'vertical-scroll',
                  event_label: '75ContentRead'
                })
              }
            }}
          />

          {/* Genres */}
          <div className='ui genres'>
            <div className='ui container section-headers'>
              <h4 className='ui header'>
                Die Lieblings-Musikstile der Generationen
              </h4>
              <div className='subheader'>
                Anteil der Songs in den Top-100, die dem entsprechenden Genre
                zugeordnet sind.
              </div>
            </div>
            <div className='ui container stackable two column grid'>
              <div className='column'>
                <img src={require('./img/rock-vs-rap.svg')} />
              </div>
              <div className='column'>
                <p>
                  Spotify kategorisiert seine Songs in Dutzende von Genres. Die
                  vier prominentesten haben wir herausgefiltert und nach
                  Präferenz der Generationen dargestellt. Auffallend ist der
                  Siegeszug des Rap in der jüngsten Generation. Sogar die bei
                  allen vorhergehenden Generationen klar dominierende Popmusik
                  wurde nun überholt.
                </p>
              </div>
            </div>
          </div>

          {/* Playlists */}
          <div className='ui playlists'>
            <div className='ui container section-headers'>
              <h4 className='ui header'>
                Die 100 beliebtesten Songs der verschiedenen Generationen
              </h4>
              <div className='subheader'>
                Meistgespielte Musiktitel bei Spotify, April 2018 bis April 2019
              </div>
            </div>
            <div className='ui container stackable two column grid'>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/56chU9lw7BlRAygQJzswIB'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/53iKekvtVT2a1iqaqemq0J'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/1RNTnnW0UNAtQmXLfIWzl4'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
              <div className='column'>
                <iframe
                  src='https://open.spotify.com/embed/playlist/4XelkPnpqbUWH15aAEaxua'
                  width='100%'
                  height='380'
                  frameBorder='0'
                  allow='encrypted-media'
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default Display
